import { ORG_IDS } from '@/constants/Organizations';

export const isNewLines9MayOrgId = (orgId: string) => orgId === ORG_IDS.NEW_LINES_9_MAY;
export const isNewLines13JuneOrgId = (orgId: string) => orgId === ORG_IDS.NEW_LINES_13_JUNE;
export const isNewLinesInstituteOrgId = (orgId: string) => orgId === ORG_IDS.NEW_LINES_INSTITUTE;
